(function () {
  var ROOT_SELECTOR = "[data-srh-recipe-index]";
  var CARD_SELECTOR = "[data-srh-recipe-card]";

  function normalize(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  function labelFor(value) {
    return String(value || "").trim();
  }

  function getCardLabel(card, name) {
    return labelFor(card.getAttribute("data-srh-recipe-" + name));
  }

  function addOption(select, value) {
    if (!select || !value) {
      return;
    }

    var option = document.createElement("option");
    option.value = value;
    option.textContent = value;
    select.appendChild(option);
  }

  function clearOptions(select) {
    if (!select) {
      return;
    }

    while (select.options.length > 1) {
      select.remove(1);
    }
  }

  function hasOption(select, value) {
    return Boolean(
      select &&
        Array.prototype.some.call(select.options, function (option) {
          return option.value === value;
        })
    );
  }

  function populateSelect(select, values) {
    if (!select) {
      return;
    }

    var sortedValues = Array.from(values).sort(function (a, b) {
      return a.localeCompare(b, undefined, { sensitivity: "base" });
    });

    sortedValues.forEach(function (value) {
      addOption(select, value);
    });
  }

  function initRecipeIndex(root) {
    if (!root || root.dataset.srhRecipeIndexReady === "true") {
      return;
    }

    root.dataset.srhRecipeIndexReady = "true";

    var searchInput = root.querySelector("[data-srh-recipe-filter-search]");
    var flavourSelect = root.querySelector("[data-srh-recipe-filter-flavour]");
    var resetButton = root.querySelector("[data-srh-recipe-reset]");
    var countOutput = root.querySelector("[data-srh-recipe-count]");
    var list = root.querySelector(".blog-articles");
    var empty = document.createElement("p");
    var pendingFrame = null;

    empty.className = "srh-recipe-index__empty";
    empty.hidden = true;
    empty.textContent = "No recipes found.";

    if (list) {
      list.after(empty);
    }

    function getCards() {
      return Array.prototype.slice.call(root.querySelectorAll(CARD_SELECTOR));
    }

    function refreshOptions(cards) {
      var flavours = new Set();
      var currentFlavour = flavourSelect && flavourSelect.value;

      cards.forEach(function (card) {
        var flavour = getCardLabel(card, "flavour");

        if (flavour) {
          flavours.add(flavour);
        }
      });

      clearOptions(flavourSelect);
      populateSelect(flavourSelect, flavours);

      if (hasOption(flavourSelect, currentFlavour)) {
        flavourSelect.value = currentFlavour;
      }
    }

    function getTerms() {
      return normalize(searchInput && searchInput.value)
        .split(/\s+/)
        .filter(Boolean);
    }

    function matchesTerms(card, terms) {
      var haystack = normalize(card.getAttribute("data-srh-recipe-search"));

      return terms.every(function (term) {
        return haystack.indexOf(term) !== -1;
      });
    }

    function applyFilters() {
      var cards = getCards();
      var terms = getTerms();
      var flavour = flavourSelect && flavourSelect.value;
      var visibleCount = 0;

      flavour = hasOption(flavourSelect, flavour) ? flavour : "";

      cards.forEach(function (card) {
        var flavourMatch = !flavour || getCardLabel(card, "flavour") === flavour;
        var searchMatch = terms.length === 0 || matchesTerms(card, terms);
        var visible = flavourMatch && searchMatch;

        card.hidden = !visible;

        if (visible) {
          visibleCount += 1;
        }
      });

      if (countOutput) {
        countOutput.textContent = visibleCount + " " + (visibleCount === 1 ? "recipe" : "recipes");
      }

      empty.hidden = visibleCount !== 0;
    }

    function resetControls() {
      if (searchInput) {
        searchInput.value = "";
      }

      if (flavourSelect) {
        flavourSelect.value = "";
      }
    }

    if (searchInput) {
      searchInput.addEventListener("input", applyFilters);
    }

    if (flavourSelect) {
      flavourSelect.addEventListener("change", applyFilters);
    }

    if (resetButton) {
      resetButton.addEventListener("click", function () {
        resetControls();
        scheduleRefresh();
        if (searchInput) {
          searchInput.focus();
        }
      });
    }

    function refreshIndex() {
      refreshOptions(getCards());
      applyFilters();
    }

    function scheduleRefresh() {
      if (pendingFrame !== null) {
        window.cancelAnimationFrame(pendingFrame);
      }

      pendingFrame = window.requestAnimationFrame(function () {
        pendingFrame = null;
        refreshIndex();
      });
    }

    if ("MutationObserver" in window) {
      var observer = new MutationObserver(scheduleRefresh);
      observer.observe(list || root, {
        attributeFilter: ["data-srh-recipe-category", "data-srh-recipe-flavour", "data-srh-recipe-search"],
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    resetControls();
    refreshIndex();
    window.setTimeout(scheduleRefresh, 250);
  }

  function initAllRecipeIndexes(scope) {
    var roots = [];

    if (scope && scope.matches && scope.matches(ROOT_SELECTOR)) {
      roots.push(scope);
    } else {
      roots = Array.prototype.slice.call((scope || document).querySelectorAll(ROOT_SELECTOR));
    }

    roots.forEach(initRecipeIndex);
  }

  initAllRecipeIndexes(document);

  document.addEventListener("shopify:section:load", function (event) {
    initAllRecipeIndexes(event.target);
  });
})();
